const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/bulb/light_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.bulb.powerDevice.title',
    secondaryTx: 'categories.bulb.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.bulb.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/bulb/light_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.bulb.confirmPairingMode.title',
    secondaryTx: 'categories.bulb.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.bulb.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.bulb.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/bulb/reset_light_step_1.png'),
          primaryTx: 'categories.bulb.resetDevice.step1.title',
          secondaryTx: 'categories.bulb.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/bulb/reset_light_step_2.gif'),
          primaryTx: 'categories.bulb.resetDevice.step2.title',
          secondaryTx: 'categories.bulb.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/bulb/reset_light_step_3.gif'),
          primaryTx: 'categories.bulb.resetDevice.step3.title',
          secondaryTx: 'categories.bulb.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
